import { APP as app } from './app';
import { ERROR as error } from './error';
import { USER as user } from './user';

export const VIEWS = {
  app,
  user,
  error
};
